import { ADDRESS_TYPE } from '../../constants/Constants';
import ShippingRepository, { IShippingAddressRepositoryConfig } from '../ShippingRepository';

class PackstationRepository extends ShippingRepository {
  constructor(props: IShippingAddressRepositoryConfig) {
    super(props);
    this.addressType = ADDRESS_TYPE.PACKSTATION;
  }
}

export default PackstationRepository;
